import './About.css'

export default function About(){
    
    return (
        <div className="about">
            <h3>About</h3>
            <p>
                I am student at National Institute of Technology, Surat. Currently I am persuaing B.Tech in Electronics as my majors and Computer Science as minors. 
                Amongst the top mind personalities, I am a normie student trying to balance my interests and academics. 
            </p>
            <h3>Interests</h3>
            <ul>
                <li>Open Source</li>
                <li>Compiler Building</li>
                <li>Linux Kernel Development</li>
                <li>Android Development</li>
                <li>Photography</li>
                <li>Cycling</li>
            </ul>
        </div>
    )
    
}